import { render, staticRenderFns } from "./ed-block-item-group.component.vue?vue&type=template&id=20c62b18&scoped=true&"
import script from "./ed-block-item-group.component.ts?vue&type=script&lang=ts&"
export * from "./ed-block-item-group.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-block-item-group.component.scss?vue&type=style&index=0&id=20c62b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c62b18",
  null
  
)

export default component.exports